import { Workflow } from "../enums/orders";
import { PickupTaskState } from "../enums/tasks";
import { IPickupTask } from "../interfaces/delivery-company/tasks";

export const emptyPickupTask: IPickupTask = {
    id: '',
    status: PickupTaskState.CREATED,
    driver: null,
    customer: null,
    merchant: null,
    orders: [],
    workflow: Workflow.STANDARD,
    merchant_location: null,
    customer_location: null,
    package_count: 0,
    driver_commission: [],
    pop: [],
    branch: null,
}
